// ============ SmartLogistics MOCK DATA + localStorage store ============
// NOTE: This is FRONTEND-ONLY mock data persisted to localStorage.
// It will be replaced by a real backend later.

import { Plane, Ship, Truck, Warehouse, ShieldCheck, PackageCheck, Home, Globe } from "lucide-react";

export const HERO_IMG = "/hero-smartlogistics.jpeg";
export const IMG_HANDOFF = "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55";
export const IMG_SCOOTER = "https://images.unsplash.com/photo-1617347454431-f49d7ff5c3b1";
export const IMG_TRUCK = "https://images.unsplash.com/photo-1695222833131-54ee679ae8e5";
export const IMG_FLEET = "https://images.unsplash.com/photo-1587813369290-091c9d432daf";
export const IMG_WAREHOUSE = "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d";
export const IMG_COURIER = "https://images.unsplash.com/photo-1659353740953-c93814e4a2a5";
export const IMG_DOORBAG = "https://images.unsplash.com/photo-1669484586012-b76d614a9df8";
export const IMG_SUPPORT1 = "https://images.pexels.com/photos/7035859/pexels-photo-7035859.jpeg";
export const IMG_SUPPORT2 = "https://images.pexels.com/photos/8867631/pexels-photo-8867631.jpeg";

export const SERVICES = [
  { icon: Home, title: "Door-to-Door Pickup", desc: "We collect your parcel from your doorstep and deliver it right to the receiver's door — no queues, no hassle." },
  { icon: Plane, title: "Air Freight", desc: "Fast, tracked air cargo for urgent and personal shipments across Europe and Asia." },
  { icon: Ship, title: "Sea Freight", desc: "Cost-effective container and bulk shipping for large parcels and commercial cargo." },
  { icon: Truck, title: "Road Transport", desc: "A modern fleet moving parcels across all of Europe and onward to the UK." },
  { icon: Warehouse, title: "Warehousing", desc: "Secure storage and consolidation before your parcel begins its journey." },
  { icon: ShieldCheck, title: "Cargo Insurance", desc: "Complete peace of mind — every insured parcel is protected door to door." },
  { icon: PackageCheck, title: "Live Tracking", desc: "Stay updated at every step, from pickup to final delivery confirmation." },
  { icon: Globe, title: "Global Corridors", desc: "Dedicated routes connecting Europe with Sri Lanka, India, Bangladesh & Philippines." },
];

// Delivery corridors / routes with country flags (emoji flags represent countries)
export const CORRIDORS = [
  { id: "eu-lk", name: "Europe → Sri Lanka", from: "🇪🇺", to: "🇱🇰", days: "5-8 days", desc: "Send parcels from anywhere in Europe straight to homes across Sri Lanka.", tag: "Most Popular" },
  { id: "it-lk", name: "Italy → Sri Lanka", from: "🇮🇹", to: "🇱🇰", days: "4-7 days", desc: "Our flagship route — fast, insured door-to-door from every Italian city.", tag: "Flagship" },
  { id: "eu-uk", name: "Europe → United Kingdom", from: "🇪🇺", to: "🇬🇧", days: "2-4 days", desc: "Quick cross-channel delivery from mainland Europe to the UK.", tag: "Express" },
  { id: "eu-in", name: "Europe → India", from: "🇪🇺", to: "🇮🇳", days: "6-9 days", desc: "Reliable door-to-door parcel delivery from Europe to India.", tag: "" },
  { id: "eu-bd", name: "Europe → Bangladesh", from: "🇪🇺", to: "🇧🇩", days: "7-10 days", desc: "Trusted shipping from European cities to homes in Bangladesh.", tag: "" },
  { id: "eu-ph", name: "Europe → Philippines", from: "🇪🇺", to: "🇵🇭", days: "8-12 days", desc: "Secure parcel service from Europe direct to the Philippines.", tag: "" },
];

// All European pickup countries (customer can search their country)
export const EU_COUNTRIES = [
  { name: "Italy", flag: "🇮🇹" }, { name: "France", flag: "🇫🇷" }, { name: "Germany", flag: "🇩🇪" },
  { name: "Spain", flag: "🇪🇸" }, { name: "Netherlands", flag: "🇳🇱" }, { name: "Belgium", flag: "🇧🇪" },
  { name: "Switzerland", flag: "🇨🇭" }, { name: "Austria", flag: "🇦🇹" }, { name: "Portugal", flag: "🇵🇹" },
  { name: "Romania", flag: "🇷🇴" }, { name: "Poland", flag: "🇵🇱" }, { name: "Sweden", flag: "🇸🇪" },
  { name: "Norway", flag: "🇳🇴" }, { name: "Denmark", flag: "🇩🇰" }, { name: "Finland", flag: "🇫🇮" },
  { name: "Ireland", flag: "🇮🇪" }, { name: "Greece", flag: "🇬🇷" }, { name: "Czechia", flag: "🇨🇿" },
  { name: "Hungary", flag: "🇭🇺" }, { name: "Luxembourg", flag: "🇱🇺" }, { name: "Malta", flag: "🇲🇹" },
  { name: "Cyprus", flag: "🇨🇾" }, { name: "Slovakia", flag: "🇸🇰" }, { name: "Slovenia", flag: "🇸🇮" },
  { name: "Croatia", flag: "🇭🇷" }, { name: "Bulgaria", flag: "🇧🇬" }, { name: "United Kingdom", flag: "🇬🇧" },
];

export const STATS = [
  { value: 27, suffix: "+", label: "Countries Served" },
  { value: 6, suffix: "", label: "Delivery Corridors" },
  { value: 24, suffix: "/7", label: "Customer Support" },
  { value: 100, suffix: "%", label: "Insured & Door-to-Door" },
];

export const TESTIMONIALS = [
  { name: "Nayana Kumari", city: "Colombo, Sri Lanka", text: "SmartLogistics picked the parcel from my door in Milan and delivered it to my daughter's home in Colombo. Incredible service!", rating: 5 },
  { name: "Kasun Priyadarshana", city: "Rome, Italy", text: "Sending gifts home has never been easier. The WhatsApp support team replied within minutes.", rating: 5 },
  { name: "Shehan Fernando", city: "Paris, France", text: "Fast, insured and truly door-to-door. I don't ship with anyone else now.", rating: 5 },
  { name: "Maria Santos", city: "Manila, Philippines", text: "My family received the package in perfect condition. Highly recommend for Europe to Philippines.", rating: 5 },
];

export const FAQS = [
  { q: "How does door-to-door delivery work?", a: "Simply send us your parcel details via the form or WhatsApp. Our courier collects the parcel from your doorstep and delivers it directly to the receiver's door — you never leave home." },
  { q: "Which countries do you pick up from?", a: "We pick up from every country in Europe, including the UK. Use the coverage search to confirm your country." },
  { q: "Where can you deliver to?", a: "We deliver across Europe, the UK, Sri Lanka, India, Bangladesh and the Philippines. New corridors are added regularly." },
  { q: "How do I get a quote?", a: "Fill in the parcel submission form with the weight and dimensions. It saves to our team and opens a pre-filled WhatsApp chat for an instant quote." },
  { q: "Is my parcel insured?", a: "Yes. Every insured parcel is fully protected from pickup to final delivery for total peace of mind." },
  { q: "How can I track my parcel?", a: "Once your submission is confirmed, our team shares live updates via WhatsApp and your customer dashboard." },
];

export const DEFAULT_SETTINGS = {
  companyName: "SmartLogistics",
  whatsapp: "393888648590",
  phone: "+39 388 864 8590",
  email: "hello@smartlogistics.eu",
  address: "Via Logistica 24, Milan, Italy",
  facebook: "https://www.facebook.com/smartlogisticseu",
  instagram: "https://www.instagram.com/smartlogisticseu/",
  tiktok: "https://www.tiktok.com/@user4817510919825",
  youtube: "",
};

// ---------------- localStorage helpers ----------------
const LS = {
  users: "sl_users",
  session: "sl_session",
  submissions: "sl_submissions",
  reviews: "sl_reviews",
  settings: "sl_settings",
};

const read = (k, fb) => { try { return JSON.parse(localStorage.getItem(k)) ?? fb; } catch { return fb; } };
const write = (k, v) => localStorage.setItem(k, JSON.stringify(v));

export function seed() {
  if (!localStorage.getItem(LS.users)) {
    write(LS.users, [
      { id: "u-admin", name: "Admin", email: "admin@smartlogistics.eu", password: "admin123", role: "admin" },
    ]);
  }
  if (!localStorage.getItem(LS.settings)) write(LS.settings, DEFAULT_SETTINGS);
  if (!localStorage.getItem(LS.reviews)) write(LS.reviews, []);
  if (!localStorage.getItem(LS.submissions)) write(LS.submissions, []);
}

export const store = {
  getUsers: () => read(LS.users, []),
  addUser: (u) => { const us = read(LS.users, []); const nu = { ...u, id: "u-" + Date.now(), role: u.role || "customer" }; write(LS.users, [...us, nu]); return nu; },
  deleteUser: (id) => write(LS.users, read(LS.users, []).filter(u => u.id !== id)),
  login: (email, password) => { const u = read(LS.users, []).find(x => x.email.toLowerCase() === email.toLowerCase() && x.password === password); if (u) write(LS.session, u); return u; },
  logout: () => localStorage.removeItem(LS.session),
  getSession: () => read(LS.session, null),

  getSettings: () => read(LS.settings, DEFAULT_SETTINGS),
  saveSettings: (s) => write(LS.settings, s),

  getSubmissions: () => read(LS.submissions, []),
  addSubmission: (s) => { const list = read(LS.submissions, []); const ns = { ...s, id: "s-" + Date.now(), createdAt: new Date().toISOString(), status: "New", reply: "" }; write(LS.submissions, [ns, ...list]); return ns; },
  updateSubmission: (id, patch) => { write(LS.submissions, read(LS.submissions, []).map(s => s.id === id ? { ...s, ...patch } : s)); },

  getReviews: () => read(LS.reviews, []),
  addReview: (r) => { const list = read(LS.reviews, []); const nr = { ...r, id: "r-" + Date.now(), createdAt: new Date().toISOString() }; write(LS.reviews, [nr, ...list]); return nr; },
};
